import { FirebaseAuthContainer } from "../../../common/containers/auth/firebase-auth-container.util";
import { LoaderView } from "../../loader/loader.comp";
import NotFound from "../../../views/not-found/not-found";

/**
 * Tenant admin-feature gate (tenant_admin_permissions_design.md §6): renders
 * the child only when `hasAdminFeature(feature)` holds (super admins always
 * pass). Compose inside the role-protected route — the server enforces the
 * same permission, this just keeps a withheld view unreachable by URL.
 */
const FeatureProtectedRoute = ({
    feature,
    children
}: {
    feature: string;
    children: JSX.Element;
}) => {
    const { user, hasAdminFeature } = FirebaseAuthContainer.useContainer();

    return user ? hasAdminFeature(feature) ? children : <NotFound /> : <LoaderView show={true} />;
};

export default FeatureProtectedRoute;
